var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
var Wrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  a {\n    display: block;\n  }\n"], ["\n  a {\n    display: block;\n  }\n"])));
var OfferListLinks = function (_a) {
    var pathPrefix = _a.pathPrefix, _b = _a.offerLists, offerLists = _b === void 0 ? [] : _b;
    if (offerLists.length === 0)
        return null;
    return (React.createElement(Wrapper, null, offerLists.map(function (_a) {
        var id = _a.id, name = _a.name;
        return (React.createElement(Link, { key: id, to: "".concat(pathPrefix, "/offer_lists/").concat(id) }, name));
    })));
};
export default OfferListLinks;
var templateObject_1;
